module.exports = __webpack_public_path__ + "static/media/middle-none-3.4b0b0602.png";